<template>
  <v-card
    :loading="loading"
    class="my-0"
  >
  <div id="download-button">
        <v-btn color="info" @click="preparePowerpoint()">
            <v-icon class="mr-1">mdi-download</v-icon>
            Download powerpoint slide</v-btn>
        <v-progress-linear indeterminate v-if="startPowerpointGeneration"></v-progress-linear>
  </div>

  <!--
      <v-btn color="warning" @click="debug">iterate over isochrones</v-btn>
      <v-btn color="warning" @click="debug2">highlight current</v-btn>
  -->
    <!-- <DownloadButton @clicked="download"/> -->
    <div>
        <div id="phantom-climate-map"
        ref="phantomClimateContainer"
        class="phantom-map"></div>
        <div id="phantom-social-map"
        ref="phantomSocialContainer"
        class="phantom-map"></div>
        <div id="isochroneInfoContainer">

        <div id="isochroneInfo" v-if="showDriveTimeTable && selectedProperty">
          <table :key="selectedProperty.location_id">
              <colgroup>
                <col></col>
                <col v-for="time in driveTimeOptions" :key="time" :class="time == focusedRadius ? 'active-col' : 'inactive-col'"></col>
              </colgroup>
              <tr>
                <th class="scoreType">Drive-time (min)</th>
                <th v-for="time in driveTimeOptions">
                  <v-btn color="info" text v-text="time" dense small @click="setfocusedRadius(time)"></v-btn>
                </th>
              </tr>
              <tr>
                <th class="scoreType">
                  {{summaryScoreLabel}}
                </th>
                <td v-for="time in driveTimeOptions" :key="`total${selectedProperty.id}-${time}`"

                >
                <!-- v-html="isochroneScores[time] ? isochroneScores[time].toHtml('total') : ''" -->
<!--
                :style="highlight(getColor(time, 'risq'), undefined,'5%','95%', '104deg','85%')"  -->
                    <div v-if = "mapMetric != 'social_impact'" :style="isHigh(time, 'risq', isochroneScores)? 'background: ' + getColor(time, 'risq'): ''" >
                        <strong>

                        {{isochroneScores[time].risq}}
                        </strong>

                    </div>

                <div v-else >
                        <p>

                       {{isochroneScores[time].social_impact_score}}
                        </p>

                    </div>


                </td>
              </tr>
              <!-- v-html="isochroneScores[time] ? isochroneScores[time].toHtml(subScore) : '' -->
              <tr v-for="subScore in featuredSubscoreTypes">
                <th v-text="subScoreLabel(subScore)" class="scoreType"></th>
                <td v-for="time in driveTimeOptions" >
                     <div  :style="isHigh(time, subScore, isochroneScores)?'background: '+getColor(time, subScore): ''" >


                            {{isochroneScores[time][subScore]}}



                    </div>

                </td>
              </tr>
          </table>
        </div>
        <div
        id="isochrone-map"
        ref="mapContainer"
        />
        </div>
      </div>
  </v-card>
</template>
<script>
import chroma from 'chroma-js'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import leafletImage from 'leaflet-image'
//import leafletEasyprint from 'leaflet-easyprint'

import { mapState, mapGetters } from 'vuex'

import {lightLayer, initMap, featureColor } from '@/utils/map.js'
import {isHigh, highlight} from '@/utils/utils'
import { mapVarSelector } from '@/components/MapVarSelector.vue'
//import DownloadButton from '@/components/DownloadButton'
import { risQScores } from '@/utils/risq_score.js'
import { SocialScores } from '@/utils/social_score.js'


export default {
  components: {
     mapVarSelector,
    // DownloadButton
  },
  data() {
    return {
        isHigh: isHigh,
        risQScores: risQScores,
      table: null,
       //printPlugin: null,
      map: null,
      pointLayer: null,
      isochroneLayer: null,
      focusedRadius: 6,
      featuresByDrivetime: {},
      hoveredRadius: 6,
      phantomClimateMap: null,
      phantomSocialMap: null,
      phantomClimateMapOptions: {mapMode: 'rscore', mapMetric: 'risq', key: 'climate', urlKind: 'climateMapUrl'},
      phantomSocialMapOptions: {mapMode: 'sscore', mapMetric: 'social_impact', key: 'social', urlKind: 'socialMapUrl'}
    }
  },
  computed: {
    isClimate() {
      return this.mapMode == 'rscore'
    },
    summaryScoreLabel() {
      return this.isClimate ? 'ICE Climate Risk Score' : 'Social Impact Score'
    },
    mapNeedsToBeInitialized() {
      return this.map === null && this.properties
      // return true
    },
    featuredSubscoreTypes() {
      if (this.mapMetric == 'social_impact') {
        return []
      } else if (this.isClimate) {
        return risQScores.subscoreTypes
      } else {
        return [`${this.mapMetric}_score`]
      }
    },
    ...mapGetters(['isochroneScores']),
    ...mapState({
      cusip: (state) => state.currentCusip,
      results: (state) => state.currentCusipData,
      summary: (state) => state.summaryData,
      properties: (state) => state.propertyData,
      mapPoints: (state) => state.mapPoints,
      loading: (state) => state.loading,
      driveTimeOptions: (state) => state.driveTimeOptions,
      selectedProperty: (state) => state.selectedProperty,
      showDriveTimeTable: (state) => state.showDriveTimeTable,
      isochrones: (state) => state.isochrones,
      mapMode: (state) => state.mapMode,
      mapMetric: (state) => state.mapMetric,
      labels: (state) => state.labels,
      powerpointData: (state) => state.powerpointData,
      powerpointDataToGenerate: (state) => state.powerpointDataToGenerate,
      startPowerpointGeneration: (state) => state.startPowerpointGeneration
    })
  },
  updated: function() {
    if (this.mapNeedsToBeInitialized) {
        const container = this.$refs.mapContainer
        this.initMap(container)
        this.updateMap()
        new ResizeObserver(this.handleResize).observe(container)
    }
  },
  methods: {
    preparePowerpoint: function() {
        this.$store.dispatch('updateState', ['startPowerpointGeneration', true]);
    },
    highlight(color, width, topLeft, bottomRight, angle, rhStart) {
       return  highlight(color, width, topLeft, bottomRight, angle, rhStart)
    },
    getColor(time, category='risq') {
        if(this.isochroneScores[time][category]< risQScores.orangePoint){
            return undefined
        }
        else {
            return chroma(risQScores.getTextColor(this.isochroneScores[time][category])).alpha(0.5).hex()
        }
    },
    makeTableIntoLControl(){
      this.table = L.control({ position: 'bottomright' })
      this.table.onAdd = function(){
        let el = L.DomUtil.get('isochroneInfo')
        return el
      }
      this.table.addTo(this.map)
    },
    // download(){
    //   this.printPlugin.printMap('CurrentSize', 'MBS ESG Custom Map');
    // },
    subScoreLabel(val) {
      return this.isClimate ? val : this.labels[val]
    },
    featureColor(feature, mapMode=this.mapMode, mapMetric=this.mapMetric) {
      return featureColor(feature, mapMode, mapMetric)
    },
    debug() {
      this.map.eachLayer(function(layer) {
        console.log(layer)
      })
    },
    debug2() {
      console.log(this.featuresByDrivetime)
      console.log(this.focusedRadius)
      console.log(this.featuresByDrivetime[this.focusedRadius])
      this.featuresByDrivetime[this.focusedRadius].setStyle({
        color: 'blue'
      })
    },
    isoFillColor(feature, mapMode, mapMetric) {
      return feature.properties.drive_time <= this.focusedRadius ? this.featureColor(feature, mapMode, mapMetric) : '#999'
    },
    updateMapAndPowerpoint: function(map=this.map, options) {
        let { mapMode, mapMetric } = options
        this.drawIsochrones(map, mapMode, mapMetric).then( isos => {
            this.updatePowerpoint(map, options)
        })
    },
    removeFromPowerpointDataToGenerate: function(urlKind) {
        let powerpointDataToGenerate = this.powerpointDataToGenerate.filter(name => name !== urlKind)
        this.$store.dispatch('updateState', ['powerpointDataToGenerate', powerpointDataToGenerate])
    },
    updatePowerpoint(map, options) {
        let { key, urlKind } = options
        let component = this //inside the function passed to leafletImage, we can't see what 'this' refers to
        leafletImage(map,
        function(err, canvas) {
            //the built-in error message is unhelpful; putting this in try/catch block tells us what's actually going wrong if there's an error
            try{
                let mapUrl = canvas.toDataURL();//get map url
                let powerpointData = component.powerpointData
                let urls = powerpointData.mapUrls || {}
                urls[key]= mapUrl
                powerpointData.mapUrls = urls
                component.$store.dispatch('updateState', ['powerpointData', powerpointData]);//updating powerpoint data with new url
                component.removeFromPowerpointDataToGenerate(urlKind)
            }
            catch(error) {
                console.log(error)
            }
        });
    },
    initMap: function(el) {
      this.map = initMap(el)
      this.map.invalidateSize()
    },
    updateMap: function() {
      if (this.isochroneLayer) {
        this.map.removeLayer(this.isochroneLayer)
        this.isochroneLayer = null
      }
      if(this.isochrones) {
        this.drawIsochrones().then( isos => {
          this.isochroneLayer = isos
        })
      }
      //need timeout to wait for table and download button to mount
      setTimeout(()=>{
         //need this so table appears in fullscreen
        this.makeTableIntoLControl()
       // this.makeButtonIntoLControl()
      }, 100);
    },
    setfocusedRadius: function(newRadius) {
      this.focusedRadius = newRadius
      this.map.invalidateSize()
    },
    isochroneStyle: function(feature, scoreType, mapMode, mapMetric) {
      // TODO: make this variable
      //const scoreType = 'total'
      return {
        fillColor: this.isoFillColor(feature, mapMode, mapMetric),
        weight: 1,
        opacity: 0.5,
        color: chroma.mix('black', this.featureColor(feature, mapMode, mapMetric)),
        fillOpacity: 0.5
      }
    },
    popupContents(feature) {
      return `
          <div class="popup-content">
            <table class="risq-score">
              <tr>
                <td style="font-size:1.25em"><b>ICE Climate Risk Score</b></td>
                <td style="font-size:1.25em"><b>${feature.properties.rscores.toHtml('total')}</b></td>
              </tr>
              <tr>
                <td class="subscore">&nbsp;&nbsp;Hurricane</td>
                <td>${feature.properties.rscores.toHtml('hurricane')}</td>
              </tr>
              <tr>
                <td class="subscore">&nbsp;&nbsp;Flood</td>
                <td>${feature.properties.rscores.toHtml('flood')}</td>
              </tr>
              <tr class="method-break-last">
                <td class="subscore">&nbsp;&nbsp;Wildfire</td>
                <td>${feature.properties.rscores.toHtml('wildfire')}</td>
              </tr>
            </table>
          </div>
        `
    },
    eachIsochrone: function(feature, layer) {
      const component = this
      feature.properties.bounds_calculated = layer.getBounds();

    //   console.log(feature.properties.bounds_calculated)
      component.featuresByDrivetime[feature.properties.drive_time] = feature

      // polygon mouseover
      layer.on('mouseover', function (e) {
        component.hoveredRadius = feature.properties.drive_time
      })
      // polygon mouseout
      layer.on('mouseout', function(e) {
        component.hoveredRadius = null
      })
      layer.on('click', function (e) {
        component.focusedRadius = feature.properties.drive_time
      })

    },
    handleResize: function() {
      this.map.invalidateSize()
      this.map.eachLayer(function(layer) {
        if( layer instanceof L.TileLayer ) {
          layer.redraw();
        }
      });
    },
    drawIsochrones: function(map=this.map, mapMode=this.mapMode, mapMetric=this.mapMetric, scoreType = 'total') {
      if (this.isochroneLayer) {
        map.removeLayer(this.isochroneLayer)
        this.isochroneLayer = null //todo: figure out if removing this even when we're drawing isochrones for the phantom map is slowing things down
      }
      return new Promise((resolve, reject) => {
        this.isochroneLayer = L.geoJson(this.isochrones, {
          style: feature => this.isochroneStyle(feature, scoreType, mapMode, mapMetric),
          onEachFeature: this.eachIsochrone
        })
        this.isochroneLayer.addTo(map);
        map.fitBounds(this.isochroneLayer.getBounds());
        map.invalidateSize();
        resolve(this.isochroneLayer)
      })
    },
    closeProperty: function(property) {
      this.$store.dispatch('updateState', ['selectedProperty', null])
      if (this.isochroneLayer) {
        this.map.removeLayer(this.isochroneLayer)
        this.isochroneLayer = null
        this.isochrones = null
      }
    }
  },
  watch: {
    focusedRadius(newRadius,oldRadius) {
      this.$store.dispatch('updateState',['focusedRadius',newRadius])
      this.drawIsochrones()
      if (this.featuresByDrivetime[newRadius]) {
        if (newRadius > oldRadius) {
          this.map.fitBounds(this.featuresByDrivetime[newRadius].properties.bounds_calculated)
        } else {
          this.map.flyToBounds(this.featuresByDrivetime[newRadius].properties.bounds_calculated, {easeLinearity: 0.1})
        }
      }
    },
    mapMetric() {
      this.updateMap()
    },
    isochrones() {
      if (this.map) {
        this.updateMap()
        this.map.invalidateSize()
      }
    },
    startPowerpointGeneration(newVal) {
        if(newVal === true) {
            let phantomClimateContainer = this.$refs.phantomClimateContainer
            //only initiate map once per container
            let phantomClimateMap = this.phantomClimateMap || initMap(phantomClimateContainer)
            this.phantomClimateMap = phantomClimateMap //set this so we don't have to reinitiate the map later
            this.updateMapAndPowerpoint(phantomClimateMap, this.phantomClimateMapOptions)

            let phantomSocialContainer = this.$refs.phantomSocialContainer
            //only initiate map once per container
            let phantomSocialMap = this.phantomSocialMap || initMap(phantomSocialContainer)
            this.phantomSocialMap = phantomSocialMap //set this so we don't have to reinitiate the map later
            this.updateMapAndPowerpoint(phantomSocialMap, this.phantomSocialMapOptions)
        }
    }
  }
}
</script>
<style scoped>
    .round{
        border-radius: 50%;
    }
    .div:hover::before {
    opacity: 0;
}

    /* .round:hover{
        background-color: rgb(255, 179, 105) !important;
    } */
  #isochrone-map {
    height: 430px;
    z-index: 1;
  }

  .phantom-map {
    height: 430px;
    width:430px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .popup-content {
    font-size: 0.93em;
  }
  th.scoreType {
    text-align: right;
    padding-right: 1em;
  }
  .v-data-table__wrapper table {
    border-collapse: collapse !important;
  }
  table {
    border-collapse: collapse !important;
  }
  .active-col {
    border: 1px solid blue;
  }
  .inactive-col {
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
  }


 #isochroneInfo {
  width:110%;
    position: absolute;
    bottom: 14px;
    right: 0px;
    /*
    border: 1px solid red;
    height:300px;
    */
    z-index: 2;
    /* max-width: 100%; */
    background-color: rgba(255,255,255,0.5);
    /* padding-left: 1.5em;
    padding-right: 1.5em; */
  }
  #isochroneInfo table {
    border-collapse: collapse !important;
  }
  #isochroneInfo table td {
    text-align: center;
  }

  #download-button {
    z-index: 2;
    position: absolute;
    top: 0;
    right: 0;
  }

  /* #isochroneInfo table {
    box-sizing: initial;
  } */

</style>
